<template>
  <dv-full-screen-container>
    <!--头部开始-->
    <el-row style="height: 10%">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
        <div class="header">
          <div class=" header_time">
            <span class="year">{{ date }}</span>
            <span class="hour" style="margin-left: 10px">{{ time }}</span>
          </div>

          <div class="header_left_nav">
            <router-link to="/">
              <button class="butt ">首页</button>
            </router-link>
          </div>
          <div class="header_left_nav nav1" style="z-index: 100000000">
            <router-link to="/Arrondi" >
              <button class="butt zq" style="left: 20%">专区</button>
            </router-link>
          </div>

          <div class=" header_title">
            <div class="header_img">
              <img src="../public/images/tixing.png" alt="">
              <div class="header_title_msg" style="left: 35%">
                线上专区
              </div>
            </div>
          </div>

          <div class=" nav2 " style="z-index: 100000000">
            <router-link to="/Special" >
              <button class="butt ">专馆</button>
            </router-link>
          </div>
          <div class=" nav3">
            <router-link to="/SpecialCoun" >
              <button class="butt ">专柜</button>
            </router-link>
          </div>
          <div class=" nav5">
            <router-link to="/Information" >
              <button class="butt" >数据</button>
            </router-link>
          </div>
          <div class=" nav4">
            <button class="butt" v-on:click="login_out">退出</button>
          </div>
          <div class="clear-both"></div>

        </div>

      </el-col>
    </el-row>
    <!--头部完毕-->
    <el-row style="height: 55%">
      <el-col :span="8" style="height: 100%">
        <dv-border-box-9>
          <el-tabs type="border-card" class="sell_box">
            <el-tab-pane label="局委帮扶列表" style="height: 100%">
              <List1 msg="表格数据" style="height: 100%" />
            </el-tab-pane>
            <el-tab-pane label="个人帮扶列表" style="height: 100%" :lazy='true'>
              <List2 msg="表格数据"/>
            </el-tab-pane>
          </el-tabs>
        </dv-border-box-9>
      </el-col>
      <el-col :span="8" style="height: 100%" :lazy='true'>
        <div class="map_all">
          <div class="map_all1">
            <span>累计消费总额（元）</span>
            <span>
              <animate-number from="100" :to="sales_data.money" :key="sales_data.money" duration="4000"></animate-number>
<!--              {{ sales_data.money }}-->
            </span>
          </div>

          <div class="map_all2">
            <span>累计帮扶总额（元）</span>
            <span>
              <animate-number from="100" :to="sales_data.profit" :key="sales_data.profit" duration="4000"></animate-number>
<!--              {{ sales_data.profit}}-->
            </span>
          </div>
          <div class="clear-both"></div>
        </div>
        <Map1 msg="地图"/>
      </el-col>
      <el-col :span="8" style="height: 100%">
        <el-col :span="24" style="height: 47%;"  :lazy='true'>
          <dv-border-box-9>
            <Bing1 msg="饼图"/>
          </dv-border-box-9>
        </el-col>
        <el-col :span="24" style="height: 47%; margin-top: 6%;" :lazy='true'>
          <dv-border-box-9>
            <div class="title_msg">帮扶销售排行榜</div>
            <div style="height: 78%">
              <SellList1 style="padding: 0 3%; width: 94%; height: 100%" msg="排行"/>
            </div>
          </dv-border-box-9>
        </el-col>
      </el-col>
    </el-row>
    <el-row style="height: 30%; margin-top: 1%;" >
      <el-col :span="8" style="height: 100%">
        <dv-border-box-9>
          <div class="title_msg">消费数据对比图</div>
          <div style="height: 80%">
            <ContrastLine1 msg="排行"/>
          </div>
        </dv-border-box-9>
      </el-col>
      <el-col :span="16" style="height: 100%">
        <dv-border-box-9>
          <div class="title_msg">实时销售数据</div>
          <div style="height: 77%">
          <XList msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
          </div>
        </dv-border-box-9>
      </el-col>
    </el-row>
  </dv-full-screen-container>
</template>

<script>
import List1 from '@/views/zhuanqu/List1.vue'
import List2 from '@/views/zhuanqu/List2.vue'
import Bing1 from '@/views/zhuanqu/Bing1.vue'
import SellList1 from '@/views/zhuanqu/SellList1.vue'
import ContrastLine1 from '@/views/zhuanqu/ContrastLine1.vue'
import XList from '@/views/zhuanqu/XList.vue'
import Map1 from '@/views/map/Map1.vue'


export default {
  name: "Arrondi",
  components: {
    List1,
    List2,
    Map1,
    Bing1,
    SellList1,
    ContrastLine1,
    XList
  },
  data() {
    return {
      sales_data: {
        "money":'',
        'profit':''
      },
      time:'',
      date:''
    }
  },
  mounted(){

    let user_id = window.localStorage.getItem('user_id');

    // if (!user_id)
    // {
    //   this.$router.push({ path: '/Login' })
    //
    //   return false;
    // }

    const data = {
      'user_id': user_id
    };

    this.$api.zq_summary(data).then(res=>
    {
      this.sales_data = res;
    })



    const that = this;
    setInterval(updateTime, 1000);
    function updateTime() {
      const cd = new Date();
      that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
      that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
    };

    function zeroPadding(num, digit) {
      let zero = '';
      for(let i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }


  },
  methods: {
    login_out:function(e){
      window.localStorage.clear();
      this.$notify({
        title: '成功',
        message: '退出登录',
        type: 'success'
      });
      this.$router.push({ path: '/Login' })
    }
  }
}


</script>

<style lang="less" scoped>
@import '../public/less/zhuanqu/zhuanqu.less';
</style>